
export function isTouchDevice() {

	////	https://ctrlq.org/code/19616-detect-touch-screen-javascript:
	//return 'ontouchstart' in window
	//	|| navigator.MaxTouchPoints > 0
	//	|| navigator.msMaxTouchPoints > 0
	//;


	// SO från 2018: https://stackoverflow.com/a/4819886/593779:

	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

	var mq = function (query) {
		return window.matchMedia(query).matches;
	};

	if (!!('ontouchstart' in window) || !!window.DocumentTouch && document instanceof window.DocumentTouch) {
		return true;
	}

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);


	// Tippys event-handler kan användas (https://atomiks.github.io/tippyjs/):

	//Disabling tooltips on touch devices
	//It can be tricky to determine touch devices accurately, especially considering the existence of hybrid devices (a mix of mouse and touch input). Simply detecting the user agent is not enough.
	//
	//A user can switch between either input type at any time which is why dynamic input detection is enabled. You can hook into Tippy's detection of user input changes by defining the following callback function:
	//
	//tippy.browser.onUserInputChange = type => {
	//  console.log('The user is now using', type, 'as an input method')
	//}
	//Whenever the user changes their input method, you can react to it inside the callback function. To disable tooltips for touch input but keep them enabled for mouse input, you can do the following:
	//
	//const tip = tippy('[title]')
	//
	//tippy.browser.onUserInputChange = type => {
	//  const method = type === 'touch' ? 'disable' : 'enable'
	//  for (const tooltip of tip.tooltips) {
	//    tooltip[method]()
	//  }
	//}
}
